import * as Yup from "yup";

const mdfeValidator = Yup.object().shape({
  fatVeiculoId: Yup.string().required("Veiculo"),
  serieDocumento: Yup.string().required("Série"),
  proprietarioVeiculoCpfCnpj: Yup.string().nullable(),
  proprietarioVeiculoUf: Yup.string().nullable(),
  proprietarioVeiculoNome: Yup.string().nullable(),
  condutores: Yup.array().min(1, "Incluir ao menos 1 condutor"),
  municipiosCarregamento: Yup.array().min(
    1,
    "Incluir ao menos 1 munícipio de carregamento"
  ),
  nfsSaida: Yup.array().min(1, "Incluir ao menos 1 nf de Saida"),
  percursos: Yup.array().nullable(),
  reboques: Yup.array().nullable(),
  ciots: Yup.array().nullable(),
  pedagios: Yup.array().nullable(),
  lacres: Yup.array().nullable(),
});

export default mdfeValidator;
